import { User as OidcClientUser, UserManager } from "oidc-client-ts";
import { AppStore } from "../store";
import { Service } from "./service";
import { AuthStateQuery } from "../queries/authStateQuery";
import { AppRouter } from "../appConfig";

export class SignInService implements Service<void, void> {
  constructor(
    private readonly store: AppStore,
    private readonly window: Window,
    private readonly oidcManager: UserManager,
    private readonly router: AppRouter,
    private readonly authStateQuery: AuthStateQuery,
  ) {}

  async call() {
    try {
      const oidcUser: OidcClientUser | null = await this.oidcManager.signinRedirectCallback();
      if (oidcUser) {
        const cleanedUpUrl = removeQueryParams(this.window.location.href, OIDC_PARAMS);
        this.window.history.replaceState({}, this.window.document.title, cleanedUpUrl);
        this.router.state.location.search = cleanedUpUrl.search;

        try {
          this.store.setState({
            authState: {
              type: "signed-in",
              user: {
                id: oidcUser.profile.sub,
                email: oidcUser.profile.email as string,
                verified: false,
                mobileNumber: (oidcUser.profile as { mobile_number?: string }).mobile_number,
              },
            },
          });

          console.debug("Logged in successfully:", oidcUser.profile);
          await this.authStateQuery.call();
        } catch (error) {
          console.debug("Error during parsing of server authentication data:", error);
          this.store.setState({ authState: { type: "error", error: error as Error } });
        }
      }
    } catch (_error) {
      try {
        const redirectUri = removeQueryParams(this.window.location.href, OIDC_PARAMS);
        await this.oidcManager.signinRedirect({
          redirect_uri: redirectUri.toString(),
        });
      } catch (signinError) {
        console.debug("Error during authentication:", signinError);
        this.store.setState({ authState: { type: "error", error: signinError as Error } });
      }
    }
  }
}

const OIDC_PARAMS = ["state", "code", "session_state", "iss"];

function removeQueryParams(href: string, params: string[]): URL {
  const url = new URL(href);
  for (const param of params) {
    url.searchParams.delete(param);
  }
  return url;
}
